<template>
  <IntegrationWorkflowWrapper
    :is-enabled="state?.accountPush === 'ALL'"
    title="Push to Account Object"
    description="Push partner overlap data into Salesforce’s standard Account object. This makes it available across the workflows, reports, dashboards, and processes your revenue team already uses every day."
    @update:is-enabled="(val) => (state.accountPush = val ? 'ALL' : 'NONE')"
  >
    <!-- TODO: workflow status will live here -->
    <AccountObjectFields v-if="state.profileType === 'salesforce'" />
  </IntegrationWorkflowWrapper>
  <PartnerFieldMappings />
</template>

<script setup lang="ts">
import { inject } from 'vue';

import { ProvidedTrayState } from '@/injectionKeys/integration_profiles';

import AccountObjectFields from './AccountObjectFields.vue';
import IntegrationWorkflowWrapper from './IntegrationWorkflowWrapper.vue';
import PartnerFieldMappings from './PartnerFieldMappings.vue';

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const state = inject(ProvidedTrayState)!;
</script>
